
export const CALLBACK_STATUS = ['init', 'retry', 'success', 'failed', 'in_progress'];

